/**
 * @param shapes 2d shapes of each region
 * @param globeRadius radius of the globe
 * @returns Region shapes in 3d space
 */
export function parseShapes(shapes: number[][], globeRadius: number): Line[] {
  const lines: Line[] = [];

  for (let i = 0; i < shapes.length; ++i) {
    const points: Line = [];

    for (let j = 0; j < shapes[i].length; j += 2) {
      const sinA = Math.sin(shapes[i][j] * Math.PI);
      const cosA = Math.cos(shapes[i][j] * Math.PI);
      const sinB = Math.sin((shapes[i][j + 1] * Math.PI) / 2);
      const cosB = Math.cos((shapes[i][j + 1] * Math.PI) / 2);

      points.push({
        sx: 0,
        sy: 0,
        x: globeRadius * cosA * cosB,
        y: globeRadius * sinB,
        z: globeRadius * sinA * cosB,
      });
    }

    lines[i] = points;
  }

  return lines;
}

interface Point {
  sx: number;
  sy: number;
  x: number;
  y: number;
  z: number;
}

type Line = Point[];
